import { render } from "./Register-admin.vue?vue&type=template&id=3e320cbc&scoped=true"
import script from "./Register-admin.vue?vue&type=script&lang=js"
export * from "./Register-admin.vue?vue&type=script&lang=js"

import "./Register-admin.vue?vue&type=style&index=0&id=3e320cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e320cbc"]])

export default __exports__